
import './App.css';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contact from './components/pages/Contact';
import Room from './components/pages/Room';
import Gallery from './components/pages/Gallery';
import Aboutus from './components/pages/Aboutus';
function App() {
  return (
      <Router>
        
    <div>
  
       
      <Routes>

     
      <Route axact path="/" element={<Home/>}/>
            <Route axact path="/SuperDeluxeRoom" element={<Room/>}/>
            <Route axact path="/Contact-us" element={<Contact/>}/>
              <Route axact path="/Gallery" element={<Gallery/>}/>
                <Route axact path="/aboutus" element={<Aboutus/>}/>
         </Routes>
    <Footer/>
  
    </div>
   
    </Router>
  );
}

export default App;
